module.exports = __webpack_public_path__ + "media/images/app/login/fb-icon-d9cd600232bacf6a82ea82e8b5164334.svg";